import * as React from 'react';

import { InputGroup, IInputGroupProps } from './InputGroup';

const SimpleInput: React.FC<IInputGroupProps> = (props) => {
  return <InputGroup {...props} />;
};

export default SimpleInput;
